import { GRAPH_COLORS } from "./constants";

export const colorForCategory = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = Math.trunc(hash * 31 + (name.codePointAt(i) ?? 0));
  }
  return GRAPH_COLORS[Math.abs(hash) % GRAPH_COLORS.length];
};
